<template>
  <transition name="myDialog">
    <div :visible.sync="dialogVisible" class="mask-layer">
      <div class="modal" :style="[modelBgi, modelCss]">
        <img v-if="showClose" class="close-img" :src="closeImage" :style="closeCss" @click="close" />
        <img v-show="showSuccess" class="success-icon" src="../../assets/Ldp/icon-success.png" />
        <slot>
          <div class="modal-content">
            <p class="modal-title">{{ errorMsg.title }}</p>
            <p class="modal-text">{{ errorMsg.content }}</p>
          </div>
        </slot>
        <div v-if="showButton" class="close-btn" @click="close" :style="`background-image: url(${closeBtnImg})`">ĐÓNG
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "inviteDialog",
  props: {
    bgi: {
      type: String
    },
    showClose: {
      type: Boolean,
      default: false
    },
    showSuccess: {
      type: Boolean,
      default: false
    },
    showButton: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: Object,
      required: true,
    },
    dialogVisible: {
      type: Boolean
    },
    closeImage: {
      type: String,
      default: require('../../assets/invite/close.png')
    },
    closeBtnImg: {
      type: String,
      default: require('../../assets/sport/bgi-btn.png')
    },
    closeCss: {
      type: Object,
      default: () => ({})
    },
    modelCss: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modelBgi: {
        backgroundImage: `url(${this.bgi})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
      }
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
@font-face {
  font-family: 'UTMMabella';
  src: url("../../assets/font/UTM-Mabella.ttf");
}

.mask-layer {
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, .7);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;

  .modal {
    position: relative;
    transform: scale(1);
    width: 2.777778rem;
    min-height: 1.07265rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img.success-icon {
      width: 19.0397%;
      position: absolute;
      top: -17%;
      left: 39.735%;
    }

    .modal-content {
      color: #fff;
      font-size: .102564rem;
      text-align: center;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      padding: .08547rem;

      .modal-title {
        font-size: .17094rem;
        font-family: UTMErieBlack;
        font-weight: bold;
        margin: 0;
        color: #FFFFFF;
      }

      .modal-text {
        font-family: UTMAvo;
        font-weight: 400;
        margin: .08547rem 0 0;
        width: 90%;
        color: #FFFFFF;
        text-align: center;
      }

      @media only screen and (min-width: 320px) and (max-width: 576px) and (orientation: portrait) {
        .modal-title {
          font-size: 22px;
        }

        .modal-text {
          font-size: 16px;
          margin-top: 10px;
        }
      }
    }

    .close-img {
      top: 0px;
      right: 0px;
      position: absolute;
      cursor: pointer;
      width: .34188rem;
      height: .179487rem;
    }

    .close-btn {
      height: 100px;
      width: 250px;
      background-size: 100% 100%;
      cursor: pointer;
      position: absolute;
      left: calc(50% - 125px);
      bottom: -50px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-family: UTMMabella;
      font-size: 32px;
    }

    @media only screen and (max-width: 767px) {
      .close-img {
        top: -15px;
        right: -15px;
        height: 40px;
        width: 40px;
      }
    }

    @media only screen and (max-width: 600px) {
      .close-img {
        top: 0px;
        right: 0px;
        height: 30px;
        width: 55px;
      }
    }

    @media only screen and (max-width: 350px) {
      .close-img {
        top: -12px;
        right: -12px;
        height: 35px;
        width: 35px;
      }
    }
  }

  @media only screen and (max-width: 350px) {
    .modal {
      padding: 20px;
    }
  }

  @media only screen and (max-width: 600px) {
    .modal {
      padding: 40px 30px;
      max-width: 75%;
      width: 75%;
    }
  }
}

.myDialog-enter-active,
.myDialog-leave-active {
  transition: all .3s;
}

.myDialog-enter,
.myDialog-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/invite/inviteDialog.vue